export enum NotificationCategory {
  LESSON = "lesson",
  PAYMENT = "payment",
  BADGE = "badge",
  DISPUTE = "dispute",
  SYSTEM = "system",
}
